export function truncateText(text: string, characters = 100): string {
  if (text.length <= characters) {
    return text;
  }

  return `${text.slice(0, characters)}...`;
}

export function truncateFilename(
  filename: string,
  maxLength = 15,
  maxBaseLength = 10,
): string {
  if (filename.length <= maxLength) {
    return filename;
  }

  const lastDotIndex = filename.lastIndexOf('.');

  if (lastDotIndex <= 0) {
    return `${filename.slice(0, maxBaseLength)}...`;
  }

  const baseName = filename.slice(0, lastDotIndex);
  const extension = filename.slice(lastDotIndex);

  if (baseName.length + extension.length <= maxLength) {
    return filename;
  }

  return `${baseName.slice(0, maxBaseLength)}...${extension}`;
}
